<div class="card shadow login-card m-auto" [formGroup]="parentForm">
  <div class="card-body accountStepperContent py-5">
    <div class="col d-flex">
      <div class="w-100">
        <div class="d-flex flex-row justify-content-between">
          <h1 class="card-title" id="card-title">Billing</h1>
          <button
            class="btn btn-primary mb-2"
            matStepperNext
            (click)="completeBillingInformation()"
            [disabled]="!isFormValid"
            type="button"
          >
            Continue
          </button>
        </div>
        <div class="d-flex flex-row">
          <div class="mr-3 mb-3" style="flex-basis: 40%">
            <div class="custom-control custom-radio custom-radio-card pl-0">
              <input
                type="radio"
                class="custom-control-input"
                formControlName="featureLevel"
                id="trial"
                name="featureLevel"
                [value]="billingLevel.TRIAL"
                [checked]="
                  parentForm.controls.featureLevel.value === billingLevel.TRIAL
                "
              />

              <label class="custom-control-label" for="trial">
                <div
                  class="card-outline mt-4"
                  [ngClass]="{
                    selected:
                      parentForm.controls.featureLevel.value ===
                      billingLevel.TRIAL
                  }"
                >
                  <div class="d-flex card border-danger shadow card-label">
                    <div class="card-body">
                      <div class="d-flex flex-row">
                        <div class="d-flex flex-column" style="flex-basis: 83%">
                          <h1
                            class="card-title text-danger font-weight-bold"
                            id="card-title"
                          >
                            TRIAL
                          </h1>
                          <span class="card-text card-line-height">
                            <p class="mb-0">
                              Access to <b>all features</b> for
                              {{ trialPeriod }}!
                            </p>

                            <p class="mb-0">Free for one user.</p>
                          </span>
                        </div>
                        <div class="d-flex flex-column align-items-end mt-4">
                          <h1 class="card-title font-weight-bold">FREE!</h1>
                        </div>
                      </div>
                      <div class="d-flex flex-row"></div>
                    </div>
                  </div>
                </div>
                <span class="sub-label"><b>Free</b> for one user</span></label
              >
            </div>
            <div class="custom-control custom-radio custom-radio-card pl-0">
              <input
                type="radio"
                class="custom-control-input"
                formControlName="featureLevel"
                id="premium"
                name="featureLevel"
                [value]="billingLevel.PREMIUM"
              />

              <label class="custom-control-label" for="premium">
                <div
                  class="card-outline mt-4"
                  [ngClass]="{
                    selected:
                      parentForm.controls.featureLevel.value ===
                      billingLevel.PREMIUM
                  }"
                >
                  <div class="d-flex card border-primary shadow card-label">
                    <div class="card-body">
                      <div class="d-flex flex-row">
                        <div class="d-flex flex-column" style="flex-basis: 58%">
                          <h1
                            class="card-title text-primary font-weight-bold"
                            id="card-title"
                          >
                            BUY PC*MILER
                          </h1>
                          <span
                            class="card-text card-line-height"
                            style="flex-basis: 58%"
                          >
                            <p class="mb-0">
                              Comprehensive set of routing options and planning
                              tools
                            </p>
                          </span>
                        </div>
                        <div class="d-flex flex-column align-items-end mt-4">
                          <h1
                            class="card-title font-weight-bold card-line-height mb-0"
                          >
                            {{
                              featureCost | displayCurrency : displayCurrency
                            }}
                          </h1>
                          <span
                            class="card-subtitle-1 font-weight-bold card-line-height"
                            >A MONTH PER USER</span
                          >
                        </div>
                      </div>
                      <div class="d-flex flex-row"></div>
                    </div>
                  </div>
                </div>
                <span class="sub-label"
                  ><b>{{ featureCost | displayCurrency : displayCurrency }}</b>
                  a month per user</span
                ></label
              >
            </div>
          </div>

          <div class="mr-3 mb-3" style="flex-basis: 60%">
            <app-dynamic-form
              [jsonFormData]="billingField"
              [displayCurrency]="displayCurrency"
              [parentForm]="parentForm"
              [controlName]="'billingForm'"
              (isdynamicFormValid)="enableContinueButton($event)"
              (controls)="useAccountAddress($event)"
            ></app-dynamic-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
